import type { ReactElement } from 'react';
import { Icon } from '../icon/index.js';
import type { PlaceholderProps } from './types.js';
import { Placeholder as _Placeholder } from '#~/common/card/index.js';

/** Position preset `<Placeholder>` component. */
export const Placeholder = (props: PlaceholderProps): ReactElement => (
  <_Placeholder icon={<Icon />} title='Add a position preset' {...props} />
);
